import { render, staticRenderFns } from "./MultilineTextBoxField.vue?vue&type=template&id=0fe4f1f8"
import script from "./MultilineTextBoxField.vue?vue&type=script&lang=js"
export * from "./MultilineTextBoxField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports